import { useLoaderData } from "react-router";
import CustomError from "@components/Error/CustomError";
import { MetaTagDescriptor } from "@components/MetaTags/MetaTags";
import { EventsAwardsGalleryPageContext } from "@events-awards/EventsAwardsGallery/utils/types";
import { getAwardType } from "@events-awards/utils/helpers";
import { Route } from "@route-types/Section/layouts/EventsAwards/EventsAwardsGalleryYear/+types/EventsAwardsGalleryYearPage";
import { ResponseType } from "@sphtech/web2-core/ssr";
import { HttpStatusCode } from "axios";

import { fetchEventsAwardsGalleryYearPageData } from "./EventsAwardsGalleryYearPage.server";
import EventsAwardsGalleryYearPageContent from "./EventsAwardsGalleryYearPageContent";

/** This is the main entry point component for /events-awards route. */
const EventsAwardsGalleryYearPage = (): React.ReactElement => {
  const context = useLoaderData<EventsAwardsGalleryPageContext>();

  // StatusCode is not 200
  if (context && context.statusCode !== HttpStatusCode.Ok) {
    return <CustomError statusCode={context.statusCode} />;
  }

  // Check if payload is missing
  if (typeof context?.payload === "undefined") {
    return <CustomError statusCode={HttpStatusCode.NotFound} />;
  }

  return <EventsAwardsGalleryYearPageContent {...context.payload.data} />;
};

export default EventsAwardsGalleryYearPage;

export const loader = async ({ request }: Route.LoaderArgs) => {
  const url = new URL(request.url, `http://localhost`);
  const path = url.pathname;

  return await fetchEventsAwardsGalleryYearPageData(getAwardType(path));
};

export const meta = ({ loaderData }: Route.MetaArgs): MetaTagDescriptor[] => {
  const context = loaderData as EventsAwardsGalleryPageContext;

  if (context.type !== ResponseType.SUCCESS) return [];

  const data = context.payload;

  if (!data) return [];
  if (!data.metaTags) return [];

  return data.metaTags;
};
